var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "common_nav_config",
      attrs: {
        disabled: _vm.disabled,
        model: _vm.value.config,
        "label-position": "left",
        "hide-required-asterisk": "",
      },
    },
    [
      _c("div", { staticClass: "label" }, [
        _vm._v(" 设置分类及排序 "),
        _c("span", { staticClass: "tips" }, [_vm._v("（拖动分类可调整排序）")]),
      ]),
      _c(
        "draggable",
        {
          attrs: { animation: "500", "force-fallback": true },
          model: {
            value: _vm.value.config.value,
            callback: function ($$v) {
              _vm.$set(_vm.value.config, "value", $$v)
            },
            expression: "value.config.value",
          },
        },
        _vm._l(_vm.value.config.value, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "box" },
            [
              _c("div", { staticClass: "header" }, [
                _c("div", [_vm._v("分类" + _vm._s(index + 1))]),
                _vm.value.config.value.length > 1
                  ? _c(
                      "div",
                      {
                        staticClass: "handle",
                        on: {
                          click: function ($event) {
                            return _vm.onDelete(index)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "el-icon-delete" }),
                        _vm._v(" 删除 "),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "value." + index + ".name",
                    rules: [
                      {
                        required: true,
                        message: "名称不可为空",
                        trigger: "change",
                      },
                    ],
                    label: "展示为",
                    "label-width": "50px",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: item.name,
                      callback: function ($$v) {
                        _vm.$set(item, "name", $$v)
                      },
                      expression: "item.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "value." + index + ".id",
                    rules: [
                      {
                        required: true,
                        message: "菜单不可为空",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      options: _vm.menuListFilter,
                      "collapse-tags": "",
                      props: {
                        label: "show_name",
                        value: "id",
                        children: "childrens",
                        checkStrictly: true,
                        emitPath: true,
                      },
                      filterable: "",
                      clearable: "",
                      placeholder: "请选择菜单",
                    },
                    on: {
                      change: function (val) {
                        return _vm.changeMenu(val, item)
                      },
                    },
                    model: {
                      value: item.id,
                      callback: function ($$v) {
                        _vm.$set(item, "id", $$v)
                      },
                      expression: "item.id",
                    },
                  }),
                ],
                1
              ),
              ["entity", "new_entity"].includes(item.menus_type)
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "0" },
                      attrs: {
                        prop: "value." + index + ".show_type",
                        rules: [
                          {
                            required: true,
                            message: "展示样式不可为空",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c("div", [_vm._v(" 选择展示样式 ")]),
                      _c(
                        "div",
                        { staticClass: "type_box" },
                        _vm._l(_vm.typeList, function (type) {
                          return _c(
                            "div",
                            {
                              key: type.id,
                              class: [
                                "type_item",
                                type.id === item.show_type && "active",
                              ],
                              on: {
                                click: function ($event) {
                                  item.show_type = type.id
                                },
                              },
                            },
                            [
                              _c("el-image", {
                                staticClass: "img",
                                attrs: { src: type.image_url, fit: "contain" },
                              }),
                              _c("div", { staticClass: "type_label" }, [
                                _vm._v(_vm._s(type.label)),
                              ]),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
              ["cake", "new_cake", "code", "entity", "new_entity"].includes(
                item.menus_type
              )
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "sort",
                      attrs: {
                        rules: [
                          { required: true, message: "商品展示逻辑不可为空" },
                        ],
                        prop: "value." + index + ".sort",
                        label: "商品展示逻辑",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: item.sort,
                            callback: function ($$v) {
                              _vm.$set(item, "sort", $$v)
                            },
                            expression: "item.sort",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "radio" },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v(
                                  " 按商品列表默认排序（即按商品ID大到小） "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "radio" },
                            [
                              _c("el-radio", { attrs: { label: "2" } }, [
                                _vm._v(
                                  " 按商品更新时间倒序展示（更新时间晚到早） "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "radio" },
                            [
                              _c("el-radio", { attrs: { label: "3" } }, [
                                _vm._v(
                                  " 按商品排序值正序展示（即按商品排序值小到大） "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "el-button",
        {
          staticClass: "el-icon-plus add_btn",
          attrs: { type: "primary" },
          on: { click: _vm.addBox },
        },
        [_vm._v(" 添加分类")]
      ),
      _c(
        "el-form-item",
        {
          staticClass: "number",
          attrs: {
            prop: "number",
            rules: [
              {
                required: true,
                pattern: /^[0-9]*$/,
                message: "数量必须为数字值",
                trigger: "change",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 商品门店数量 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入商品门店数量", clearable: "" },
            model: {
              value: _vm.value.config.number,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "number", _vm._n($$v))
              },
              expression: "value.config.number",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }